import { ContainerActivity, ActivityModel } from '.';

export class OnCompletedActivity extends ContainerActivity<ActivityModel> {
  constructor(options?: Partial<OnCompletedActivity>) {
    super(options);

    this.type = 'on-completed-activity';
    this.activities = [];
    this.name = 'On Completed Steps';
    this.description =
      'Use this activity to define a set of activities to run on omplete.';
    this.isContainer = true;

    if (options) {
      Object.assign(this, options);
    }
  }
}
